export enum PaginationTable {
  USERS = 'users',
  COURSES = 'courses',
  EXAMS = 'exams',
  AUDITS = 'audits',
}

export interface SearchRequest {
  search_by?: PaginationTable;
  search_string: string;
  offset?: number;
  audit_of_interest?: boolean;
}

export interface CourseDto {
  availableExams: number;
  courseName: string;
  courseUsers: number;
  partnerUuid: string;
  courseUuid: string;
}

export interface ICourse extends CourseDto {
  uuid: string;
}

export interface ExamDto {
  courseName: string;
  courseUuid: string;
  examEndDate: string;
  examName: string;
  examStartDate: string;
  examUuid: string;
  partnerUuid: string;
  proctoring: string;
  sessionsCount: number;
}

export interface IExam extends ExamDto {
  uuid: string;
}

export interface UserDto {
  auditUuid: string;
  courseName: string;
  courseUuid: string;
  duration: string;
  email: string;
  examName: string;
  examUuid: string;
  firstName: string;
  lastName: string;
  partnerUuid: string;
  practiceExam: boolean;
  recordOnlyExam: boolean;
  sessionEndDate: string;
  sessionStartDate: string;
  sessionStatus: string;
  sessionUuid: string;
  shortExam: boolean;
  userUuid: string;
  auditOfInterest: boolean;
}

export interface IUser
  extends Omit<
    UserDto,
    | 'userUuid'
    | 'firstName'
    | 'lastName'
    | 'auditUuid'
    | 'courseUuid'
    | 'examUuid'
    | 'practiceExam'
    | 'recordOnlyExam'
    | 'shortExam'
  > {
  uuid: string;
  name: string;
}
export enum auditStatus {
  INCOMPLETE = 'Incomplete Audit',
  IN_QUEUE = 'Audit Queue',
  NEEDS_REVIEW = 'Needs Review',
}

export interface AuditDto {
  sessionUuid: string;
  partnerUuid: string;
  courseUuid: string;
  examUuid: string;
  auditUuid: string;
  partnerName: string;
  userName: string;
  userEmail: string;
  courseName: string;
  examName: string;
  examStart: string;
  examEnd: string;
  duration: string;
  status: string;
}

export interface IAudit extends Omit<AuditDto, 'status'> {
  uuid: string;
  status: auditStatus;
}

export interface SearchDto {
  users: UserDto[];
  courses: CourseDto[];
  exams: ExamDto[];
  audits: AuditDto[];
  usersCount: number;
  coursesCount: number;
  examsCount: number;
  auditsCount: number;
}

export interface ISearch extends Omit<SearchDto, 'users' | 'courses' | 'exams' | 'audits'> {
  users: IUser[];
  courses: ICourse[];
  exams: IExam[];
  audits: IAudit[];
}
